import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { updateMobileDevice } from '../reducers/reducer';

const useWindowResize = () => {
  const dispatch = useDispatch();

  const handleResize = () => {
    dispatch(updateMobileDevice());
  };

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [dispatch]);
};

export default useWindowResize;
